(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("SakanaWidget", [], factory);
	else if(typeof exports === 'object')
		exports["SakanaWidget"] = factory();
	else
		root["SakanaWidget"] = factory();
})(self, () => {
return 